import type { CategoryType } from "@/types";

export interface CategoryMeta {
  key: CategoryType;
  label: string;
  enLabel: string;
  description: string;
  genres: string[];
}

export const categories: CategoryMeta[] = [
  {
    key: "movie",
    label: "电影",
    enLabel: "Movies",
    description: "电影频道——涵盖最新上映与经典口碑佳作，类型丰富，总有一部适合你。",
    genres: ["剧情", "动作", "科幻", "悬疑", "惊悚", "爱情", "历史", "犯罪", "冒险", "家庭"],
  },
  {
    key: "tv",
    label: "电视剧",
    enLabel: "TV Series",
    description: "电视剧频道——热播剧集与高分口碑剧集齐聚，追剧不迷路。",
    genres: ["剧情", "犯罪", "悬疑", "古装", "奇幻", "爱情", "都市", "青春", "权谋", "治愈"],
  },
  {
    key: "variety",
    label: "综艺",
    enLabel: "Variety",
    description: "综艺频道——旅行、音乐、美食与喜剧，承包你的快乐与放松时光。",
    genres: ["旅行", "真人秀", "音乐", "竞演", "生活", "美食", "喜剧", "情景"],
  },
  {
    key: "documentary",
    label: "纪录片",
    enLabel: "Documentary",
    description: "纪录片频道——自然、历史与人文纪实，用真实镜头看见世界的辽阔。",
    genres: ["自然", "生态", "历史", "人文", "社会", "美食"],
  },
];

export const getCategoryMeta = (type: string): CategoryMeta | undefined =>
  categories.find((item) => item.key === type);

export const regionOptions = ["中国大陆", "中国香港", "日本", "韩国"];

export const sortOptions = [
  { key: "latest", label: "最新发布" },
  { key: "rating", label: "评分最高" },
  { key: "hot", label: "热门度" },
] as const;